import '.h{display:flex;}.ssr-plugin'
import '.l{justify-content:center;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.j{align-items:center;}.ssr-plugin'
import '.ai{gap:0.5rem;}.ssr-plugin'
import '.ao{cursor:pointer;}.ssr-plugin'
import '.dk{padding:0.75rem;}.ssr-plugin'
import '.ab{border-radius:1.25rem;}.ssr-plugin'
import '.aj{border:var(--blue-border);}.ssr-plugin'
import '.ac{background-color:var(--shades-white);}.ssr-plugin'
import '.dc{transition:background-color 0.2s ease;}.ssr-plugin'
import '.cs{width:2.5rem;}.ssr-plugin'
import '.ct{height:2.5rem;}.ssr-plugin'
import '.h2{color:var(--shades-blue-700);}.ssr-plugin'
import '.h3{font-size:0.9rem;}.ssr-plugin'
import '.b1{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="h l i j ai ao dk ab aj ac dc"
        style={{
          '&:hover': {
            backgroundColor: 'var(--shades-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="cs ct h j l h2"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="h3 h2 b1"
        >
          {label}
        </span>
      </styled.button>
    )
}